import React from 'react';

const PasswordCrackingPreview = () => {
  return (
    <div className="bg-dark-600 rounded-2xl p-6 mb-8">
      <div className="flex justify-between items-center mb-5">
        <h3 className="font-bold text-lg flex items-center">
          <i className="fas fa-key mr-2 text-accent-purple"></i>
          Password Cracking
        </h3>
        <div className="text-sm text-gray-400">
          <i className="fas fa-lock mr-1"></i> Locked until port is selected
        </div>
      </div>
      <div className="h-48 flex items-center justify-center">
        <div className="text-center">
          <div className="mb-4 w-16 h-16 rounded-full bg-dark-500 flex items-center justify-center mx-auto">
            <i className="fas fa-key text-gray-400 text-2xl"></i>
          </div>
          <p className="text-gray-400 mb-3">Select a detected RCON port to begin password cracking</p>
          <button
            disabled
            className="px-6 py-2 bg-dark-500 text-gray-500 rounded-lg text-sm cursor-not-allowed"
          >
            Start Password Cracker
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordCrackingPreview;